<template>
    <transition name="fade">
        <div class="notification-personal-data" v-if="show">
            <!-- <h3 class="notification-personal-data__header">Использование cookies</h3> -->
            <p class="notification-personal-data__description">
                Для улучшения работы сайт SimpleEstate может собирать файлы cookies,
                в&nbsp;том числе посредством метрической программы «Яндекс&nbsp;метрика».
                Обработка осуществляется согласно условиям <a v-bind:href="urls.policies.privacyPolicy" target="_blank">политики
                конфиденциальности</a>.
                Продолжая работу с&nbsp;сайтом, Вы даёте своё <a v-bind:href="urls.policies.consent.cookie" target="_blank">согласие</a>
                на&nbsp;обработку персональных данных.
            </p>
            <div class="notification-personal-data__buttons">
                <ui-button
                    v-on:click="() => select({ consent: 0, date: Date.now() })"
                    text="Отклонить"
                    theme="secondary"
                    size="sm"
                />
                <ui-button
                    v-on:click="() => select({ consent: 1, date: Date.now() })"
                    text="Принять"
                    theme="primary"
                    size="sm"
                />
            </div>
        </div>
    </transition>
</template>

<script>
import config from '~/config';

export default {
    name: 'notification-personal-data',
    props: [ 'onSelect', 'index' ],
    data: () => ({
        show: false,
        urls: config.urls,
    }),
    mounted() {
        window.setTimeout(() => {
            this.show = true;
        }, 10 * 1000);
    },
    methods: {
        select(choose) {
            this.onSelect(choose, this.index);
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.notification-personal-data {
    .notification();

    display: flex;
    align-items: center;

    padding-inline: 8px;
    padding-block: 8px;

    bottom: 0;

    &__header {
        .typography-heading();

        margin: 0;
    }

    &__description {
        .typography-caption();

         margin: 0;
    }

    &__buttons {
        width: 320px;
        margin: 0 auto;

        display: flex;
        align-items: center;
        gap: 4px;
    }

    @media @media-sm-down {
        padding-inline: 4px;
        padding-top: 12px;
        flex-direction: column;

        &__description {
            margin-bottom: 8px;
        }
    }
}
</style>
